import { memo, useCallback, useState, useMemo } from 'react';
import { ButtonTabs } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import ServicePageWrapper from '@Components/ServicePageWrapper';
import CreditSlimBanner from '@Components/CreditSlimBanner/CreditSlimBanner';
import Banner from '../Banner';
import styles from './Tabs.module.css';

import type { BannerData } from '@Components/CreditSlimBanner/typings';
import type { FC, HTMLAttributes } from 'react';
import type { Tab } from '@divlab/divanui';

export interface TabsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  items: BannerData[];
}

const Tabs: FC<TabsProps> = (props) => {
  const { items, ...restProps } = props;
  const { isMobile } = useMedias();
  const [firstBanner] = items;
  const [selectedTab, setSelectedTab] = useState(firstBanner.id);

  const tabs = useMemo(() => {
    return items.map((item) => ({ id: item.id, label: item.name }));
  }, [items]);

  const selectedBanner = useMemo(() => {
    return items.find((item) => item.id === selectedTab);
  }, [items, selectedTab]);

  const handleChangeTab = useCallback((_e, tab: Tab) => {
    setSelectedTab(tab.id);
  }, []);

  return (
    <div {...restProps}>
      {tabs.length > 1 && (
        <ServicePageWrapper>
          <div className={styles.buttonTabsWrapper}>
            <ButtonTabs
              scrollable={isMobile}
              defaultValue={selectedTab}
              tabs={tabs}
              onChangeTab={handleChangeTab}
            />
          </div>
        </ServicePageWrapper>
      )}

      {selectedBanner.view === 'slim' && (
        <div id={selectedBanner.id}>
          <CreditSlimBanner className={styles.bankBanner} banner={selectedBanner} />
        </div>
      )}

      {selectedBanner.view === 'fat' && (
        <Banner className={styles.bankBanner} banner={selectedBanner} />
      )}
    </div>
  );
};

export default memo(Tabs);
